import { render, staticRenderFns } from "./HomeworkDesktop.vue?vue&type=template&id=a73a678e&"
import script from "./HomeworkDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeworkDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports